export enum AppLanguage {
  English = 'en'
}
